import settings from '../../config/settings';
import AddCounselorNew from './addCounselorNew';
import AddCounselorLegacy from './addCounselorLegacy';

// The redesigned staff application and the original form are interchangeable at this one
// point. Flipping REACT_APP_USE_NEW_STAFF_FORM swaps them; no consumer changes.
//
// The swap lives at the path every consumer already imports (App.js for /addcounselor and
// /signup-staff, editCounselor.js, campPersonnelProfileEdit.js), so nothing downstream has to
// know the flag exists. Both components are connect()ed default exports taking the same
// Details / HideEditmode / onSaved props.
//
// Turning the flag off also needs ENABLE_STAFF_FORM_V2 off in the API: the legacy form sends no
// emailed confirmation code and no answers to director-added questions, both of which the v2
// endpoints require. See the rollback ordering in the toggle plan.
export default settings.USE_NEW_STAFF_FORM ? AddCounselorNew : AddCounselorLegacy;
